import React from "react";
import "./PlatformWidget.scss";
import { Link } from "react-router-dom";
import { Icon, Popup } from "semantic-ui-react";
import AddIcon from "../../../../../assets/svg/add-icon.svg";

function PlatformWidget({ name, icon, path, setPlatform, changeIsPlatformOpened, counts, isDisabled }) {
    return (
        <Popup
            inverted
            content={name === "TikTok" && isDisabled ? "Please upgrade your package to configure TikTok" : "Add Profile"}
            trigger={
                <div
                    className={`platformWidget ${name === "TikTok" && isDisabled && "disabled"}`}
                    onClick={() => {
                        if (name === "TikTok" && isDisabled) return;
                        else {
                            setPlatform(path);
                            changeIsPlatformOpened(true);
                        }
                    }}>
                    <div>
                        <img className="platformIcon" src={icon} alt="platform icon" />
                    </div>
                    <p>{name}</p>

                    <img src={AddIcon} className="platformButton" />
                    {counts[path] && (
                        <div className="accountCount">
                            <p>
                                <Icon color="green" name="check square outline" />
                            </p>
                            <p>{counts[path]}</p>
                        </div>
                    )}
                </div>
            }
            style={{ backgroundColor: "#1f2e3d" }}
        />
    );
}

export default PlatformWidget;
